// removed by extract-text-webpack-plugin
module.exports = {"wrapperV2":"_3KlD0","carouselV2":"_3zfjq","showUpPlanV2":"_2vNqN","headerV2":"_2jOz-","image":"_3Q8Ny","planName":"_2RSnb","price":"FcGdp","selected":"_31SmH","primary":"_1u6ta","benefits":"FpTfY","planInfo":"_FIwB","planBenefitValue":"_1Xuog","roofLink":"_28D3b","selectButton":"_26KFF","compareButton":"eFwka","oldPrice":"_3Tgmf","flexColumn":"_3X4g6","pricePix":"_2LcBZ","pricePerson":"_2HDyU","priceAtually":"_32Ez5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/plans_table/HighligthPlans/styles.module.css
// module id = 84
// module chunks = 0